"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
define('service/workflow',['require','exports','module','appkit/service','underscore','backbone','../model/assignment'],function (require, exports, module) {
  var Service = require('appkit/service');
  var _ = require('underscore');
  var Backbone = require('backbone');
  var AssignmentModel = require('../model/assignment');
  var changeBoardMsg = 'By returning back to the board set up screen, all assigned reviewers will be notified that they are being removed from reviewing the submission. The submission will also be removed from any open meetings. Are you sure you would like to proceed?';
  var changeReviewersMsg = 'By returning back to the assign reviewer screen, all assigned reviewers will be notified to stop their review of the submission. Are you sure you would like to proceed?';
  var ChangeBoardStep = {
    shortName: 'Review Type/Board',
    name: 'Change Review Type/Board',
    value: 'BOARD',
    basicModal: true,
    icon: 'warning circle',
    approveBtn: {
      text: 'Proceed',
      color: 'red'
    },
    denyBtn: {
      inverted: true
    },
    confirm: changeBoardMsg
  };
  var ChangeReviewersStep = {
    shortName: 'Reviewers',
    name: 'Change Reviewers',
    value: 'REVIEWER',
    basicModal: true,
    icon: 'warning circle',
    approveBtn: {
      text: 'Proceed',
      color: 'red'
    },
    denyBtn: {
      inverted: true
    },
    confirm: changeReviewersMsg
  };
  var Task_Answers_Mapping = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({
    EDIT_COMPLETE: {
      answers: []
    },
    CERTIFY: {
      answers: [{
        shortName: 'Return',
        name: 'Return To Investigators',
        value: 'NO'
      }, {
        name: 'Certify',
        confirmTemplateCode: 'IRB.CERTIFICATION.RESEARCHER',
        value: 'YES'
      }]
    },
    IRB_ADMIN_REVIEW: {
      answers: [{
        shortName: 'Return',
        name: 'Return To Edit',
        value: 'NO'
      }, {
        shortName: 'Proceed',
        name: 'Proceed',
        value: 'YES'
      }]
    },
    IRB_RETURN_TO_INVESTIGATOR: {
      answers: [{
        shortName: 'Return',
        name: 'Return To Investigators',
        value: 'NO'
      }, {
        shortName: 'Administratively Certify',
        name: 'Administratively Certify',
        confirmTemplateCode: 'IRB.CERTIFICATION.RESEARCHER',
        value: 'ADMIN_CERTIFY'
      }]
    },
    ANALYST_RETURN: {
      answers: [{
        shortName: 'Return',
        name: 'Return To Investigators',
        value: 'RETURN'
      }]
    },
    ORG_APPROVED: {
      answers: [{
        name: 'Reject',
        value: 'NO'
      }, {
        name: 'Approve',
        confirmTemplateCode: 'IRB.CERTIFICATION.ORG_APPROVER',
        value: 'YES'
      }]
    },
    IRB_ANALYST_SELECTED: {
      answers: [{
        name: 'Proceed',
        value: 'YES'
      }]
    },
    STUDY_CLOSURE_MAKE_DECISION: {
      answers: [{
        shortName: 'Return',
        name: 'Return To Edit',
        value: 'NO'
      }, {
        shortName: 'Proceed',
        name: 'Proceed',
        value: 'YES'
      }]
    },
    IRB_ANALYST_REVIEW_CLOSE: {
      answers: [{
        shortName: 'Withdraw',
        name: 'Withdraw Submission',
        value: 'YES'
      }, {
        name: 'Return To Investigators',
        value: 'NO'
      }]
    },
    IRB_ANALYST_TASKS_DONE: {
      answers: [{
        shortName: 'Return',
        name: 'Return To Investigators',
        value: 'NO'
      }, {
        name: 'Withdrawal',
        value: 'WITHDRAWL',
        icon: 'warning circle icon',
        approveBtn: {
          text: 'Withdraw',
          color: 'red'
        },
        confirm: 'By withdrawing this submission, you will be withdrawing the entire study from review. If you still wish to submit this submission, you will have to restart your application from the beginning. Are you sure you would like to proceed?'
      }, {
        shortName: 'Proceed',
        name: 'Proceed to Reviewers',
        value: 'YES'
      }]
    },
    IRB_ANALYST_ASSIGN_REVIEWERS: {
      answers: [{
        shortName: 'Return',
        name: 'Return To Investigators',
        value: 'NO'
      }, ChangeBoardStep, {
        name: 'Proceed',
        value: 'YES'
      }]
    },
    IRB_ANALYST_CHANGE_ASSIGNMENTS: {
      answers: [ChangeBoardStep, ChangeReviewersStep]
    },
    IRB_FULL_REVIEW_COMPLETE: {
      answers: [{
        shortName: 'Return',
        name: 'Return To Investigators',
        value: 'NO'
      }, ChangeBoardStep, ChangeReviewersStep, {
        name: 'Review Complete',
        value: 'YES'
      }]
    },
    IRB_FULL_EXPEDITED_REVIEW: {
      answers: [{
        name: 'Review Complete',
        value: 'YES'
      }]
    },
    IRB_FULL_EXPEDITED_POST_REVIEW: {
      answers: [{
        shortName: 'Redo',
        name: 'Redo Review',
        confirm: 'Are you sure you want to redo the review?  This will remove any unsent letters that have been created.',
        value: 'REDO'
      }, ChangeBoardStep, ChangeReviewersStep, {
        name: 'Post Review Complete',
        value: 'YES'
      }]
    },
    LIMITED_IRB_REVIEW_COMPLETE: {
      answers: [{
        shortName: 'Redo',
        name: 'Redo Review',
        confirm: 'Are you sure you want to redo the review?  This will remove any unsent letters that have been created.',
        value: 'REDO'
      }, ChangeBoardStep, ChangeReviewersStep, {
        name: 'Post Review Complete',
        value: 'YES'
      }]
    },
    EXPEDITED_REVIEW_COMPLETE: {
      answers: [{
        shortName: 'Redo',
        name: 'Redo Review',
        confirm: 'Are you sure you want to redo the review?  This will remove any unsent letters that have been created.',
        value: 'REDO'
      }, ChangeBoardStep, ChangeReviewersStep, {
        name: 'Post Review Complete',
        value: 'YES'
      }]
    },
    ADMINISTRATIVE_REVIEW_COMPLETE: {
      answers: [{
        shortName: 'Redo',
        name: 'Redo Review',
        confirm: 'Are you sure you want to redo the review?  This will remove any unsent letters that have been created.',
        value: 'REDO'
      }, ChangeBoardStep, ChangeReviewersStep, {
        name: 'Post Review Complete',
        value: 'YES'
      }]
    },
    IRB_EXEMPT_POST_REVIEW: {
      answers: [{
        shortName: 'Redo',
        name: 'Redo Review',
        confirm: 'Are you sure you want to redo the review?  This will remove any unsent letters that have been created.',
        value: 'REDO'
      }, ChangeBoardStep, ChangeReviewersStep, {
        name: 'Post Review Complete',
        value: 'YES'
      }]
    },
    IRB_EXEMPT_REVIEW_COMPLETE: {
      answers: [{
        shortName: 'Switch',
        name: 'Switch to Expedited',
        value: 'SWITCH'
      }, {
        name: 'Proceed',
        value: 'YES'
      }]
    },
    LIMITED_IRB_PRIMARY_REVIEW: {
      answers: [{
        shortName: 'Switch',
        name: 'Switch to Exempt',
        value: 'SWITCH'
      }, {
        name: 'Review Complete',
        value: 'YES'
      }]
    },
    LIMITED_IRB_MEMBER_REVIEW: {
      answers: [{
        name: 'Review Complete',
        value: 'YES'
      }]
    },
    IRB_EXPEDITED_PRIMARY_REVIEW: {
      answers: [{
        shortName: 'Switch',
        name: 'Switch to Exempt',
        value: 'SWITCH'
      }, {
        name: 'Review Complete',
        value: 'YES'
      }]
    },
    IRB_MEMBER_EXPEDITED_REVIEW: {
      answers: [{
        name: 'Review Complete',
        value: 'YES'
      }]
    },
    ADMINISTRATIVE_PRIMARY_REVIEW: {
      answers: [{
        shortName: 'Switch',
        name: 'Switch to Exempt',
        value: 'SWITCH'
      }, {
        name: 'Review Complete',
        value: 'YES'
      }]
    },
    IRB_MEMBER_ADMINISTRATIVE_REVIEW: {
      answers: [{
        name: 'Review Complete',
        value: 'YES'
      }]
    },
    IRB_ANALYST_CLOSURE: {
      answers: [{
        shortName: 'Return',
        name: 'Return To Investigators',
        value: 'NO'
      }, {
        shortName: 'Close',
        name: 'Close this study',
        value: 'YES',
        confirm: 'Are you sure you want to close this study?'
      }]
    },
    STUDY_WITHDRAWAL_MAKE_DECISION: {
      answers: [{
        shortName: 'Return',
        name: 'Return To Edit',
        value: 'NO'
      }, {
        shortName: 'Proceed',
        name: 'Proceed',
        value: 'YES'
      }]
    },
    IRB_ANALYST_WITHDRAWAL: {
      answers: [{
        shortName: 'Return',
        name: 'Return To Investigators',
        value: 'NO'
      }, {
        shortName: 'Withdraw',
        name: 'Withdraw this study',
        value: 'YES',
        confirm: 'Are you sure you want to withdraw this study?'
      }]
    },
    IRB_ADMIN_EDIT: {
      answers: []
    }
  }, "IRB_ADMIN_REVIEW", {
    answers: [{
      shortName: 'Return',
      name: 'Return To Edit',
      value: 'NO'
    }, {
      shortName: 'Proceed',
      name: 'Proceed',
      value: 'YES'
    }]
  }), "IRB_ADMIN_MANAGE_LETTERS", {
    answers: [{
      shortName: 'Return',
      name: 'Return To Edit',
      value: 'NO'
    }, {
      name: 'Review Complete',
      value: 'YES',
      confirm: 'By closing or withdrawing the study, no other submissions can be made. Are you sure you want to end this study?'
    }]
  }), "IRB_LEGACY_COMPLETE", {
    answers: []
  }), "IRB_RESEARCHER_REVIEW", {
    answers: []
  }), "IRB_MEMBER_REVIEW", {
    answers: []
  });
  var Workflow_Task_Mapping = _defineProperty(_defineProperty(_defineProperty(_defineProperty({
    EDIT_COMPLETE: {
      activities: [{
        displayName: 'Assign PI',
        action: 'assignPrincipalInvestigator'
      }, {
        displayName: 'Assign PC',
        action: 'assignPrimaryContact'
      }, {
        displayName: 'Complete Submission',
        action: 'completeSubmission'
      }]
    },
    CERTIFY: {},
    IRB_RETURN_TO_INVESTIGATOR: {},
    IRB_ADMINISTRATIVELY_CERTIFY: {},
    ANALYST_RETURN: {},
    ORG_APPROVED: {},
    IRB_ANALYST_SELECTED: {
      activities: [{
        displayName: 'Assign Analyst',
        action: 'assignAnalyst',
        select: true
      }]
    },
    IRB_ANALYST_REVIEW_CLOSE: {},
    IRB_ANALYST_TASKS_DONE: {
      activities: [{
        displayName: 'Assign Review Type/Board',
        action: 'setupBoard'
      }]
    },
    IRB_ANALYST_ASSIGN_REVIEWERS: {
      activities: [{
        displayName: 'Assign Reviewers',
        action: 'setupReviewers'
      }]
    },
    IRB_FULL_REVIEW_COMPLETE: {
      activities: [{
        displayName: 'Assign to Meeting',
        action: 'assignToMeeting'
      }, {
        displayName: 'Make Decision',
        action: 'makeDecision'
      }, {
        displayName: 'Manage Letters',
        action: 'manageLetters'
      }]
    },
    IRB_FULL_EXPEDITED_REVIEW: {
      activities: [{
        displayName: 'Make Decision',
        action: 'makeDecision'
      }]
    },
    IRB_FULL_EXPEDITED_POST_REVIEW: {
      activities: [{
        displayName: 'Make Decision',
        action: 'makeDecision'
      }, {
        displayName: 'Manage Letters',
        action: 'manageLetters'
      }]
    },
    LIMITED_IRB_REVIEW_COMPLETE: {
      activities: [{
        displayName: 'Make Decision',
        action: 'makeDecision'
      }, {
        displayName: 'Manage Letters',
        action: 'manageLetters'
      }]
    },
    EXPEDITED_REVIEW_COMPLETE: {
      activities: [{
        displayName: 'Make Decision',
        action: 'makeDecision'
      }, {
        displayName: 'Manage Letters',
        action: 'manageLetters'
      }]
    },
    ADMINISTRATIVE_REVIEW_COMPLETE: {
      activities: [{
        displayName: 'Make Decision',
        action: 'makeDecision'
      }, {
        displayName: 'Manage Letters',
        action: 'manageLetters'
      }]
    },
    IRB_EXEMPT_POST_REVIEW: {
      activities: [{
        displayName: 'Make Decision',
        action: 'makeDecision'
      }, {
        displayName: 'Manage Letters',
        action: 'manageLetters'
      }]
    },
    IRB_EXEMPT_REVIEW_COMPLETE: {
      activities: [{
        displayName: 'Make Decision',
        action: 'makeDecision'
      }]
    },
    LIMITED_IRB_PRIMARY_REVIEW: {
      activities: [{
        displayName: 'Make Decision',
        action: 'makeDecision'
      }]
    },
    LIMITED_IRB_MEMBER_REVIEW: {
      activities: [{
        displayName: 'Make Decision',
        action: 'makeDecision'
      }]
    },
    IRB_EXPEDITED_PRIMARY_REVIEW: {
      activities: [{
        displayName: 'Make Decision',
        action: 'makeDecision'
      }]
    },
    IRB_MEMBER_EXPEDITED_REVIEW: {
      activities: [{
        displayName: 'Make Decision',
        action: 'makeDecision'
      }]
    },
    ADMINISTRATIVE_PRIMARY_REVIEW: {
      activities: [{
        displayName: 'Make Decision',
        action: 'makeDecision'
      }]
    },
    IRB_MEMBER_ADMINISTRATIVE_REVIEW: {
      activities: [{
        displayName: 'Make Decision',
        action: 'makeDecision'
      }]
    },
    STUDY_CLOSURE_MAKE_DECISION: {
      activities: [{
        displayName: 'Make Decision',
        action: 'makeDecision'
      }]
    },
    IRB_ANALYST_CLOSURE: {
      activities: [{
        displayName: 'Manage Letters',
        action: 'manageLetters'
      }, {
        displayName: 'Assign Review Board',
        action: 'setupBoard'
      }]
    },
    STUDY_WITHDRAWAL_MAKE_DECISION: {
      activities: [{
        displayName: 'Make Decision',
        action: 'makeDecision'
      }]
    },
    IRB_ANALYST_WITHDRAWAL: {
      activities: [{
        displayName: 'Manage Letters',
        action: 'manageLetters'
      }]
    },
    IRB_ADMIN_EDIT: {
      activities: [{
        displayName: 'Complete Submission',
        action: 'completeSubmission'
      }]
    },
    IRB_ADMIN_REVIEW: {
      activities: [{
        displayName: 'Make Decision',
        action: 'makeDecision'
      }]
    },
    IRB_ADMIN_MANAGE_LETTERS: {
      activities: [{
        displayName: 'Manage Letters',
        action: 'manageLetters'
      }]
    }
  }, "IRB_ADMIN_REVIEW", {
    activities: [{
      displayName: 'Make Decision',
      action: 'makeDecision'
    }]
  }), "IRB_LEGACY_COMPLETE", {
    activities: [{
      displayName: 'Complete Submission',
      action: 'completeSubmission'
    }]
  }), "IRB_RESEARCHER_REVIEW", {}), "IRB_MEMBER_REVIEW", {});
  var WorkflowService = Service.extend({
    inject: [],
    getRequiredTasks: function getRequiredTasks(task) {
      var taskAnswers = Workflow_Task_Mapping[task.get('taskType').taskName] || {};
      return new Backbone.Collection((taskAnswers.activities || []).slice(0));
    },
    getAnswers: function getAnswers(task) {
      var taskName = task.get('taskType').taskName,
        taskAnswers = ((Task_Answers_Mapping[taskName] || {}).answers || []).slice(0),
        available = task.get('taskType').taskAnswers;
      taskAnswers = _.filter(taskAnswers, function (answer) {
        return available.indexOf(answer.value) > -1;
      });
      taskAnswers.forEach(function (answer) {
        answer.shortName = answer.shortName || answer.name;
      });
      return new Backbone.Collection(taskAnswers);
    },
    requestChangeAnalyst: function requestChangeAnalyst(submission, person) {
      var assignment = new AssignmentModel({
        person: person
      });
      return assignment.requestChangeAnalyst(submission.get('id')).promise().tap(function () {
        submission.trigger('updateAll');
      });
    },
    requestAction: function requestAction(task, submission) {
      var submissionService = this.service('submission');
      switch (task.get('action')) {
        case 'assignPrincipalInvestigator':
        case 'assignPrimaryContact':
        case 'completeSubmission':
          submissionService.navigateToFormViewer(submission);
          break;
        case 'manageLetters':
          submissionService.navigateToDocumentLetters(submission);
          break;
        case 'makeDecision':
          submissionService.navigateToDocumentDecision(submission);
          break;
      }
    }
  });
  module.exports = WorkflowService;
});

